;(function () {
  angular
    .module('contrast.org-stats')
    .controller('OrgStatsDrilldownCtrl', [
      'HistoryService',
      OrgStatsDrilldownCtrl
    ])

  function OrgStatsDrilldownCtrl(HistoryService) {
    var vm = this

    angular.extend(vm, {
      close: close
    })

    function close() {
      HistoryService.goBack('reports/stats', function (params) {
        return '/' + params.orgUuid + '/reports'
      })
    }
  }
})()
